import sportsApi from '../../utils/sportsApi';

export const getRightsholderTextTrackingFilters = async ({ clientId }) => {
    const rightsholderEndpoint = `/clients/${clientId}/rightsholders-with-oo-accounts`;
    const rightsholderTextTrackingFiltersEndpoint = `/clients/${clientId}/text-tracking-filters`;

    const [rightsholderTextTrackingFiltersResponse, rightsholdersResponse] =
        await Promise.all([
            sportsApi
                .url(rightsholderTextTrackingFiltersEndpoint)
                .get()
                .json()
                .catch(() => []),
            sportsApi
                .url(rightsholderEndpoint)
                .get()
                .json()
                .catch(() => []),
        ]);

    return {
        rightsholderTextTrackingFilters: Array.isArray(
            rightsholderTextTrackingFiltersResponse,
        )
            ? rightsholderTextTrackingFiltersResponse
            : [],
        rightsholders: Array.isArray(rightsholdersResponse)
            ? rightsholdersResponse
            : [],
    };
};
